module.exports = __webpack_public_path__ + "img/hotel-boutique.74d7a669.png";